module.exports = __webpack_public_path__ + "img/ps-19.5de94003.jpg";